import React from 'react';

// NOTE: All text content is now managed in LanguageContext.tsx for easier translation.
// These functions simply retrieve the structured data from the translation object.
// FIX: Added defensive checks to prevent app crash if data is missing during translation merge.

export const getServicesData = (t: any) => {
    return t?.data?.services || [];
}

export const getUnitsData = (t: any) => {
    return t?.data?.units || [];
}

export const getTimelineData = (t: any) => {
    return t?.data?.timeline || [];
}

export const getProjectsData = (t: any) => {
    return t?.data?.projects || [];
}